import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faQuestionCircle, faUser } from "@fortawesome/free-regular-svg-icons";
import { faBook, faGraduationCap, faSuitcase } from "@fortawesome/free-solid-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";

export const DashboardData = ({data}) => {
     const { usersCount, hndSubs, tutSubs, questionsCount, videosCount, notesCount} = data;
    return (
        <div className="stat-table">
            <table className="stats">
                <tr>
                    <td className="heading">
                        <FontAwesomeIcon icon={faUser} className="tab-icon" />
                        Users
                    </td>
                    <td className="data">{usersCount}</td>
                </tr>
                <tr>
                    <td className="heading">
                        <FontAwesomeIcon icon={faFilePdf} className="tab-icon" />
                        Lecture notes
                    </td>
                    <td className="data">{notesCount}</td>
                </tr>
                <tr>
                    <td className="heading">
                        <FontAwesomeIcon icon={faGraduationCap} className="tab-icon" />
                        HND past Q/A subscriptions
                    </td>
                    <td className="data">{hndSubs}</td>
                </tr>
                <tr>
                    <td className="heading">
                        <FontAwesomeIcon icon={faSuitcase} className="tab-icon" />
                        Job postings
                    </td>
                    <td className="data">0</td>
                </tr>
                <tr>
                    <td className="heading">
                        <FontAwesomeIcon icon={faBook} className="tab-icon" />
                        Tutorial subscriptions
                    </td>
                    <td className="data">{tutSubs}</td>
                </tr>
                <tr>
                    <td className="heading">
                        <FontAwesomeIcon icon={faQuestionCircle} className="tab-icon" />
                        Questions
                    </td>
                    <td className="data">{questionsCount}</td>
                </tr>
                <tr>
                    <td className="heading">
                        <FontAwesomeIcon icon={faYoutube} className="tab-icon" />
                        Videos
                    </td>
                    <td className="data">{videosCount}</td>
                </tr>
            </table>
        </div>
    )
}